/**
 * Migração one-time das chaves de armazenamento `fismatek-*` → `nautmax-*`.
 *
 * Roda como efeito de import (antes dos stores zustand/persist lerem o localStorage),
 * preservando as preferências já salvas dos usuários (tema, cidade do tempo, som,
 * permissão de notificação, KPIs do painel, feed de eventos). Deve ser o PRIMEIRO
 * import do main.tsx.
 */

const RENAMES: [string, string][] = [
  ['fismatek-theme', 'nautmax-theme'],
  ['fismatek-weather-city', 'nautmax-weather-city'],
  ['fismatek-notif-sound', 'nautmax-notif-sound'],
  ['fismatek-notif-enabled', 'nautmax-notif-enabled'],
  ['fismatek-dashboard-kpis', 'nautmax-dashboard-kpis'],
  ['fismatek-events-feed', 'nautmax-events-feed'],
];

try {
  for (const [oldKey, newKey] of RENAMES) {
    const v = localStorage.getItem(oldKey);
    if (v === null) continue;
    if (localStorage.getItem(newKey) === null) localStorage.setItem(newKey, v);
    localStorage.removeItem(oldKey);
  }
} catch {
  /* localStorage indisponível — ignora */
}
